<core-helpers-navigation-vertical-tabs-approvals-status 
  [menu]="approvalsStatusMenu" 
  [fullMatch]="match"
  (menuClick)="onMenuClick($event)"
></core-helpers-navigation-vertical-tabs-approvals-status>
<!-- [fullMatch]="match" -->